(() => {
  const initMenu = () => {
    const toggle = document.querySelector(".menu-toggle");
    const nav = document.getElementById("mobile-navigation");
    if (!toggle || !nav || toggle.dataset.ready === "true") return;
    toggle.dataset.ready = "true";
    toggle.addEventListener("click", () => {
      const open = toggle.getAttribute("aria-expanded") !== "true";
      toggle.setAttribute("aria-expanded", String(open));
      nav.classList.toggle("nav-open", open);
    });
    nav.querySelectorAll("a").forEach((link) => link.addEventListener("click", () => {
      toggle.setAttribute("aria-expanded", "false");
      nav.classList.remove("nav-open");
    }));
  };

  const initReveals = () => {
    const elements = document.querySelectorAll(".reveal-up:not([data-reveal-ready])");
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const element = entry.target;
        const replay = element.hasAttribute("data-replay-reveal");
        const video = element.querySelector(".reveal-video");
        if (entry.isIntersecting && entry.intersectionRatio >= (replay ? 0.45 : 0.12)) {
          element.classList.add("is-visible");
          if (video) {
            video.currentTime = 0;
            video.play().catch(() => undefined);
          }
          if (!replay) observer.unobserve(element);
        } else if (replay && entry.intersectionRatio < 0.08) {
          element.classList.remove("is-visible");
          if (video) {
            video.pause();
            video.currentTime = 0;
          }
        }
      });
    }, { threshold: [0.08, 0.12, 0.45] });

    elements.forEach((element) => {
      element.dataset.revealReady = "true";
      observer.observe(element);
    });
  };

  const initGallery = () => {
    document.querySelectorAll(".marquee-track:not([data-marquee-ready])").forEach((track) => {
      track.dataset.marqueeReady = "true";
      let offset = 0;
      let previous = performance.now();
      const animate = (now) => {
        const delta = Math.min(40, now - previous);
        previous = now;
        offset -= delta * 0.028;
        const halfway = track.scrollWidth / 2;
        if (halfway > 0 && Math.abs(offset) >= halfway) offset += halfway;
        track.style.transform = `translate3d(${offset}px,0,0)`;
        requestAnimationFrame(animate);
      };
      requestAnimationFrame(animate);
    });
  };

  const initHeroVideo = () => {
    document.querySelectorAll(".hero-product-video:not([data-video-ready])").forEach((video) => {
      video.dataset.videoReady = "true";
      video.muted = true;
      video.defaultMuted = true;
      video.setAttribute("muted", "");

      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        video.pause();
        return;
      }

      video.play().catch(() => undefined);
    });
  };

  const init = () => {
    initMenu();
    initReveals();
    initGallery();
    initHeroVideo();
    document.documentElement.classList.remove("no-js");
  };

  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);
})();
